
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/playlist/[slug]",
      function () {
        return require("private-next-pages/playlist/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/playlist/[slug]"])
      });
    }
  